import { defineComponent } from "vue";
import BaseModal from "@/components/Shared/Modals/BaseModal/BaseModal.vue";
import ResultCard from "@/components/ResultCard/ResultCard.vue";
import html2canvas from "html2canvas";
import ThemesHelper from "@/helpers/ThemesHelper";
import GoogleAnalyticsEvents from "@/helpers/GoogleAnalyticsEvents";

export default defineComponent({
  components: {
    BaseModal,
    ResultCard,
  },
  data() {
    return {
      downloadStyle: false,
      sharingCard: false,
    };
  },
  methods: {
    toggleModal(status: boolean) {
      const el: any = this.$refs["base-modal"];
      el.toggleBaseModal(status);
    },
    async getImageResultCard() {
      const printableContainer: HTMLElement = document.getElementById(
        "printable-container"
      ) as HTMLElement;
      printableContainer.style.padding = "1px";
      const canvas = await html2canvas(printableContainer);
      printableContainer.style.padding = "0px";

      return canvas.toDataURL();
    },
    async socialShare() {
      GoogleAnalyticsEvents.SharedByWhatsapp();
      this.sharingCard = true;

      // a delay is required to get right screenshot
      setTimeout(async () => {
        const imageResultCard = await this.getImageResultCard();
        const res: Response = await fetch(imageResultCard);
        const blob: Blob = await res.blob();
        const socialShareInfo = ThemesHelper.getThemeParams("socialShareInfo");

        const file = new File(
          [blob],
          "Cartão Resultado autoteste COVID-19.png",
          { type: blob.type }
        );
        this.sharingCard = false;
        if (!this.isIOSDevice()) {
          await navigator.share({
            files: [file],
            title: "Cartão Resultado autoteste COVID-19",
            text: socialShareInfo,
          } as ShareData);
        } else {
          // IOS Whatsapp does not support sending text and images
          await navigator.share({
            files: [file]
          } as ShareData);
        }
      }, 1);
    },
    isIOSDevice() {
      const platform = navigator.userAgent.toLowerCase();
      return platform.includes("iphone") || platform.includes("ios");
    },
  },
});
